const Cross = (theme, translateX = 23, translateY = 35, symbolColor = '') => {
  const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  group.setAttribute(
    'transform',
    `scale(0.5) translate(${translateX} ${translateY})`,
  );

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute(
    'd',
    'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
  );
  path.setAttribute('fill', symbolColor);
  path.setAttribute('stroke', 'none');

  group.appendChild(path);
  return group;
};

export default Cross;
